import React from 'react'
import { Header, Navbar } from '../components/layout'
import './AppLayout.css'

interface AppLayoutProps {
  children: React.ReactNode
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  return (
    <div className="app-layout">
      <Header />
      <Navbar />
      <main className="app-layout__main">
        <div className="app-layout__content">
          {children}
        </div>
      </main>
    </div>
  )
}
